export default __webpack_public_path__ + "static/media/labelLogo.3dc4063c.png";